import { useMemo } from 'react'
import { parse } from 'qs'
import clsx from 'classnames'
import { useFormatPrice, openWebview } from '@docs/common'
import { isDiscountAvailable, parseDiscount, getMallDomain, getLanguae } from 'common/util'

import styles from './index.module.scss'

const GrandSale = ({
  product,
  image,
  price,
  discount,
  sku,
  befortrigger,
  art_id
}: IProduct & { befortrigger: () => void, art_id: string }) => {
  // const { locale = 'en-US' } = parse(window.location.search, { ignoreQueryPrefix: true })
  // const formatPrice = useFormatPrice(locale as string)

  // start_ai_generated
  const language = getLanguae(); // 获取默认系统语言设置
  const parsedQuery = parse(window.location.search, { ignoreQueryPrefix: true });
  const locale = parsedQuery.locale || language; // 如果查询字符串中没有 locale，则使用 language
  const formatPrice = useFormatPrice(locale as string);
  // end_ai_generated

  const discountInfo = useMemo(() => parseDiscount(discount?.value), [discount?.value])

  const discountValue = useMemo(() => {
    if (!discountInfo) return null
    if (discountInfo.type === 'fixed_amount') return discountInfo.discount
    return Number(price) - Number(price) * (discountInfo.discount / 100)
  }, [discountInfo, price])

  const goToProductPage = async () => {
    befortrigger && befortrigger()
    const domain = await getMallDomain()
    const search = `utm_source=app&utm_medium=tutorial&utm_content=&utm_campaign=${art_id}&utm_term=`
    const url = `${domain}/products/variant/${product?.handle}/${sku}?${search}`

    openWebview(url)
  }

  const isDiscountAvail = useMemo(() => isDiscountAvailable(discountInfo), [discountInfo])

  return (
    <div className={styles.news} onClick={goToProductPage}>
      <img src={image?.url} alt={product.title} />
      <p>{product.title}</p>
      {discountValue && isDiscountAvail && <p className={styles.discount}>{formatPrice(discountValue)}</p>}
      <p className={clsx(styles.discount, { [styles.invalid]: isDiscountAvail })}>{formatPrice(+price)}</p>
    </div>
  )
}

export default GrandSale
